function setOpenGraphMeta (seoMetadata) {
  // Get meta tag elements
  const tagOgUrl = document.querySelector('meta[property="og:url"]')
  const tagOgTitle = document.querySelector('meta[property="og:title"]')
  const tagOgDescription = document.querySelector('meta[property="og:description"]')
  const tagOgImage = document.querySelector('meta[property="og:image"]')

  // Set meta tag content
  if (tagOgUrl && tagOgUrl.setAttribute && seoMetadata.ogUrl) {
    tagOgUrl.setAttribute('content', seoMetadata.ogUrl)
  }
  if (tagOgTitle && tagOgTitle.setAttribute && seoMetadata.ogTitle) {
    tagOgTitle.setAttribute('content', seoMetadata.ogTitle)
  }
  if (tagOgDescription && tagOgDescription.setAttribute && seoMetadata.ogDescription) {
    tagOgDescription.setAttribute('content', seoMetadata.ogDescription)
  }
  if (tagOgImage && tagOgImage.setAttribute && seoMetadata.ogImage) {
    tagOgImage.setAttribute('content', seoMetadata.ogImage)
  }
}

module.exports = setOpenGraphMeta
